module.exports = __webpack_public_path__ + "static/media/safra_opt.b39ca842.svg";